module.exports = __webpack_public_path__ + "media/proksee-viewer/images/icon-bold-5202c0a58c7dec7b1e1c63095786fa1e.png";